import styles from './style.module.css';

export default function Item({ label, value, children }) {
	if (children) {
		return <div className={styles.column}>
			<span className={styles.label}>{label}:</span>
			<div className={styles.address}>
				{children}
			</div>
		</div>
	}
	return <div className={styles.line}>
		<span className={styles.label}>{label}:</span>
		<span className={styles.value}>{value}</span>
	</div>;
}